<app-boton-accion id="botonFirmante" mat-button (botonClicked)="clicked()" [titulo]="descripcion" [outline]="true" [outlineYellow]="true" [cancelar]="false"></app-boton-accion>
